export const actionTypes = {
  REQUEST_START: 'CONTACTS.APPOINTMENT.GET_SERVICES.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.GET_SERVICES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.GET_SERVICES.REQUEST_FAILURE',
};

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data, id) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { id, data },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
